import { render, staticRenderFns } from "./Panelistas.vue?vue&type=template&id=48db672a&"
import script from "./Panelistas.vue?vue&type=script&lang=js&"
export * from "./Panelistas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports